// extracted by mini-css-extract-plugin
module.exports = {"component":"PaginationButtons_component__3UZAO","text":"PaginationButtons_text__n6_is","button":"PaginationButtons_button__7hJWR"};